import { call, put, takeEvery } from "redux-saga/effects"

// Ecommerce Redux States
import {
  GET_CUSTOMER_DETAIL,
  GET_CUSTOMERS,
  UPDATE_CUSTOMER,
  DELETE_CUSTOMER,
  UPDATE_CUSTOMER_FIELD,
} from "./actionTypes"

import {
  deleteCustomerFail,
  deleteCustomerSuccess,
  getAuthUsersFail,
  getAuthUsersSuccess,
  getCustomerDetailFail,
  getCustomerDetailSuccess,
  getCustomersFail,
  getCustomersSuccess,
  updateCustomerFail
} from "./actions"

//Include Both Helper File with needed methods
import {
  getCustomers,
  getCustomerDetail,
  getCustomerComents as getCustomerComentsApi, 
  getAuthUsersResponse,
  updateCustomers,
  deleteCustomersURL,
  updateCustomersField
} from "helpers/fakebackend_helper"

function* fetchCustomers(props) {
  try {
  
    const response = yield call(getCustomers, props.payload)
    yield put(getCustomersSuccess(response))
  } catch (error) {
    yield put(getCustomersFail(error))
  }
}

function* updateCustomersFun(props) {
  try {

    const response = yield call(updateCustomers, props.payload)
    yield put(updateCustomerSuccess(response))
  } catch (error) {
    yield put(updateCustomerFail(error))
  }
}

function* updateCustomersFieldFun(props) {
  try {
        
    const response = yield call(updateCustomersField, props.payload)
    yield put(updateCustomerSuccess(response))
  } catch (error) {
    yield put(updateCustomerFail(error))
  }
}



function* fetchAuthUsers() {
  
  try {
    const response = yield call(getAuthUsersResponse) 
    yield put(getAuthUsersSuccess(response))
  } catch (error) {
    yield put(getAuthUsersFail(error))
  }
}

function* fetchCustomerDetail({ customerId }) {
  try {
    const response = yield call(getCustomerDetail, customerId)
    yield put(getCustomerDetailSuccess(response))
  } catch (error) {
    yield put(getCustomerDetailFail(error))
  }
}
function* deleteCustomers(payload ) {
  try {
    const response = yield call(deleteCustomersURL, customerId.payload)
    yield put(deleteCustomerSuccess(response))
  } catch (error) {
    yield put(deleteCustomerFail(error))
  }
}

function* customersSaga() {
  yield takeEvery(GET_CUSTOMERS, fetchCustomers)
  yield takeEvery(GET_CUSTOMER_DETAIL, fetchCustomerDetail)
  yield takeEvery(UPDATE_CUSTOMER, updateCustomersFun)
  yield takeEvery(UPDATE_CUSTOMER_FIELD, updateCustomersFieldFun)
  yield takeEvery(DELETE_CUSTOMER,deleteCustomers)
  // yield takeEvery(GET_AUTH_USER, fetchAuthUsers)
}

export default customersSaga
